module.exports = __webpack_public_path__ + "img/order1.369d04c1.svg";